<template>
  <div class="d-flex flex-column justify-center fill-height">
    <div class="text-center text-h1 font-weight-bold">404</div>
    <wave class="text-center" />
  </div>
</template>

<script>
import Wave from "@/components/Wave";

export default {
  name: "NotFound",
  components: { Wave }
};
</script>
